import React, { useState } from "react";
import { Link } from "react-router-dom";
import cn from "classnames";
import styles from "./Item.module.sass";

const Item = ({ item, className }) => {
  const [imageError, setImageError] = useState(false);
  
  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <Link className={cn(styles.item, className)} to={item.url}>
      <div className={styles.preview}>
        <img 
          srcSet={!imageError ? `${item.image2x} 2x` : undefined}
          src={!imageError ? item.image : "/images/content/lifestyle-photo-1.png"} 
          alt={item.title}
          onError={handleImageError}
        />
      </div>
      <div
        className={cn(
          `status-${item.category}`,
          styles.category
        )}
      >
        {item.categoryContent}
      </div>
      <div className={styles.title}>{item.title}</div>
      <div className={styles.foot}>
        <div className={styles.user}>
          <div className={styles.avatar}>
            <img src={item.avatar} alt="Avatar" />
          </div>
          <div className={styles.author}>{item.author}</div>
        </div>
        <div className={styles.date}>{item.date}</div>
      </div>
    </Link>
  );
};

export default Item;
